import { UIIcon } from "./ui-icon";
import { UIIconName, UIIconVariant } from "./ui-icon-type";

import styles from "./ui-icon-button.module.css";
import { filterClasses } from "PosterEditor/utils/filter-classes";

interface UIIconButtonProps {
  iconName: UIIconName;
  onClick: () => void;
  width?: number;
  height?: number;
  padding?: number;
  isSelected?: boolean;
  className?: string;
  unclickable?: boolean; //Will not respond to clicks.
  disabled?: boolean; //Will not respond to clicks and will be greyed out.
}

export const UIIconButton = (props: UIIconButtonProps) => {
  const defaultSize = 40;
  return (
    <button
      key={props.iconName}
      className={filterClasses(
        styles.button,
        props.className,
        props.isSelected && styles.selected,
        props.disabled && styles.disabled,
        props.unclickable && styles.unclickable
      )}
      onClick={props.onClick}
      style={{
        width: props.width ?? defaultSize,
        height: props.height ?? defaultSize,
        padding: props.padding ?? 0,
      }}
    >
      <UIIcon
        iconName={props.iconName}
        variant={props.isSelected ? "SELECTED" : "REGULAR"}
        size={(props.width ?? defaultSize) - (props.padding ?? 0) * 2}
      />
    </button>
  );
};

export const DeleteButton = (props: { onClick: () => void }) => {
  return (
    <UIIconButton
      iconName="BIN"
      onClick={() => {
        props.onClick();
      }}
      padding={5}
      width={30}
    />
  );
};

export const BackButton = (props: { onClick: () => void }) => {
  return (
    <UIIconButton
      iconName="CHEVRON-LEFT"
      width={34}
      padding={5}
      onClick={props.onClick}
    />
  );
};

export const DragHandle = () => {
  return (
    <UIIconButton
      iconName="DRAG-HANDLE"
      width={34}
      padding={5}
      onClick={() => {}}
    />
  );
};
